(function ($) {

    api.accessibilities = {
    
        ARIA_toggleContent: function (obj, bool) {
			$(obj).attr({'aria-expanded':bool,'aria-selected':bool});
		},

		Aria_controls: function (obj, controlObjId) {
			$(obj).attr('aria-controls', controlObjId);
		},

    }

})(jQuery);